<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style>
html,
body {
  font-size: 10px;
  margin: 0;
  padding: 0;
}

*{
    margin:0px;
    padding:0px;
}
#app {
  position: absolute;
    top: 0px;
    bottom: -1px;
    left: 0;
    right: -1px;
    border: 0;
    overflow-x: hidden;
}

.van-checkbox__label {
  font-size: 2.4rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #959ab5 !important;
  margin-left: 1.4rem !important;
}

.van-button--primary {
  color: #fff !important;
  background: #0b1039 !important;
  border-radius: 1rem !important ;
  border: 0 !important;
  width: 59.6rem !important;
  height: 9.6rem !important;
}

.van-button__text {
  font-size: 3.7rem !important;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
